import { Home } from '../pages/home/index';
import GeneralTermsAndConditions from '../pages/GeneralTermsAndConditions';
import ResponsibleGaming from '../pages/ResponsibleGaming';
import SportsBettingRules from '../pages/SportsBettingRules';
import GeneralBonusTermsAndConditions from '../pages/GeneralBonusTermsAndConditions';
import PrivacyPolicy from '../pages/PrivacyPolicy';
import PaymentRules from '../pages/PaymentRules';
import AmlPolicy from '../pages/AmlPolicy';
import EstrelabetCulturalCompetitionTerms from '../pages/EstrelabetCulturalCompetitionTerms';
type Router = {
	name: string;
	path: string;
	element?: JSX.Element;
	children?: Router[];
};

export const routes: Router[] = [
	{
		name: 'Home',
		path: '/',
		element: <Home />,
	},
	{
		name: 'General Terms and Conditions',
		path: '/general_terms_and_conditions',
		element: <GeneralTermsAndConditions />,
	},
	{
		name: 'Responsible Gaming',
		path: '/responsible_gaming',
		element: <ResponsibleGaming />,
	},
	{
		name: 'Sports Betting Rules',
		path: '/sports_betting_rules',
		element: <SportsBettingRules />,
	},
	{
		name: 'General Bonus Terms And Conditions',
		path: '/general_bonus_terms_and_conditions',
		element: <GeneralBonusTermsAndConditions />,
	},
	{
		name: 'Privacy Policy',
		path: '/privacy_policy',
		element: <PrivacyPolicy />,
	},
	{
		name: 'Payment Rules',
		path: '/payment_rules',
		element: <PaymentRules />,
	},
	{
		name: 'Aml Policy',
		path: '/aml_policy',
		element: <AmlPolicy />,
	},
	{
		name: 'Estrelabet Cultural Competition Terms',
		path: '/estrelabet_cultural_competition_terms',
		element: <EstrelabetCulturalCompetitionTerms />,
	},
];
